import { useEffect, useState } from "react";
import withLoader from "../../../components/layouts/WithLoader";
import TierAccountService from "../../../services/PayementSolde/TierAccountService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import DataTableAccountImpayes from "./DataTableAccountTransactions";

const DetailsImpayesFournisseur = ({ startLoading, stopLoading }) => {
  const [alertMessage, setAlertMessage] = useState("");
  const [listTransaction, setListTransaction] = useState([]);
  const [tier, setTier] = useState();
  const [tierAccount, setTierAccount] = useState();
  const [impayed, setImpayed] = useState();

  useEffect(() => {
    startLoading();
    TierAccountService.getImpeyedFicheFournisseurByTiers(
      getCurrentUserId(),
      localStorage.getItem("idTiers")
    )
      .then((response) => {
        if (response.data.success) {
          setListTransaction(response.data.list);
          setImpayed(response.data.impayed);
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });

    // TierAccountService.getWalletByTier(getCurrentUserId(), localStorage.getItem("idTiers"))
    // .then((response) => {
    //   setSoldeInfo(response.data.success);
    //   setBtnSoldeClicked(true);
    // })
    // .catch((error) => {
    //   setAlertMessage("error " + error);
    // })
    // .finally(() => {
    //   stopLoading();
    // });
  }, []);

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">
                Les impayés du Fournisseur <b>{localStorage.getItem("nameTiers")}</b>
              </h5>

              <br />
              <br />
              <div className="row">
                <div className="col-sm-6">
                  {" "}
                  {impayed && (
                    <>
                      <b>Impayés : </b> {impayed}{" "}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              {listTransaction.length !== 0 && (
                <DataTableAccountImpayes listTransaction={listTransaction} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default withLoader(DetailsImpayesFournisseur);




